import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

import { ProgressSpinnerDirective } from 'vcp-common-ui-lib';

@Component({
    selector: 'vc-chart-wrapper',
    imports: [ProgressSpinnerDirective],
    templateUrl: './chart-wrapper.component.html',
    styleUrls: ['./chart-wrapper.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class ChartWrapperComponent {
    /** Title to use for header. Overrides [chartActionsTitle] if set. **/
    @Input()
    title!: string;

    @Input()
    contentHeight!: string;

    @Input()
    loading = false;

    @Input()
    formContainer = true;

    @Input()
    showHeader = true;
}
